import { literalValues } from "@shared/validation/literal-values";

export const ORDER_SOURCE = {
  MARKETPLACE: "marketplace",
  ADMIN_QUOTE: "admin_quote",
  MANUAL_ENTRY: "manual_entry",
  CSV_IMPORT: "csv_import",
  INTEGRATION_SYNC: "integration_sync",
  TEMPLATE: "template",
  RECURRING: "recurring",
  REORDER: "reorder",
} as const;

export type OrderSource = (typeof ORDER_SOURCE)[keyof typeof ORDER_SOURCE];

export const ORDER_SOURCE_LABEL: Record<OrderSource, string> = {
  marketplace: "Marketplace checkout",
  reorder: "Buyer reorder",
  manual_entry: "Entered by staff",
  admin_quote: "Accepted quote",
  template: "Order template",
  recurring: "Recurring order",
  integration_sync: "Integration sync",
  csv_import: "CSV import",
};

export const ORDER_SOURCES = literalValues(ORDER_SOURCE);

export const ORDER_SOURCE_CHANNEL = {
  SELF_SERVE: "self_serve",
  ADMIN: "admin",
  IMPORTED: "imported",
  UNKNOWN: "unknown",
} as const;

export type OrderSourceChannel =
  (typeof ORDER_SOURCE_CHANNEL)[keyof typeof ORDER_SOURCE_CHANNEL];

export const ORDER_SOURCE_CHANNELS = literalValues(ORDER_SOURCE_CHANNEL);

export const ORDER_SOURCE_TO_CHANNEL: Record<OrderSource, OrderSourceChannel> =
  {
    [ORDER_SOURCE.MARKETPLACE]: ORDER_SOURCE_CHANNEL.SELF_SERVE,
    [ORDER_SOURCE.REORDER]: ORDER_SOURCE_CHANNEL.SELF_SERVE,
    [ORDER_SOURCE.MANUAL_ENTRY]: ORDER_SOURCE_CHANNEL.ADMIN,
    [ORDER_SOURCE.ADMIN_QUOTE]: ORDER_SOURCE_CHANNEL.ADMIN,
    [ORDER_SOURCE.TEMPLATE]: ORDER_SOURCE_CHANNEL.ADMIN,
    [ORDER_SOURCE.RECURRING]: ORDER_SOURCE_CHANNEL.ADMIN,
    [ORDER_SOURCE.INTEGRATION_SYNC]: ORDER_SOURCE_CHANNEL.IMPORTED,
    [ORDER_SOURCE.CSV_IMPORT]: ORDER_SOURCE_CHANNEL.IMPORTED,
  };

export function orderSourceChannelOf(
  source: OrderSource | undefined,
): OrderSourceChannel {
  return source ? ORDER_SOURCE_TO_CHANNEL[source] : ORDER_SOURCE_CHANNEL.UNKNOWN;
}
